"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContent = exports.PopupHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.PopupHeader = styled_components_1.default.img `
	display: block;
	border-radius: 4px;
	max-width: 100%;
	height: auto;
`;
exports.MainContent = styled_components_1.default.div `
	margin: 2rem 0 0;
	text-align: center;

	h1 {
		font-size: 0.8rem;
		color: ${props => props.theme.color.brand1};

		strong {
			font-weight: normal;
			margin: 0.3rem 0 0;
			font-size: 2rem;
			display: block;
			color: ${props => props.theme.color.brand2};
		}

		em {
			font-weight: bold;
			font-style: normal;
		}
	}

	.main {
		padding: 1em;
		color: ${props => props.theme.color.black};
		margin: 1rem 0 0;
		font-size: 1rem;
		em {
			font-weight: bold;
			font-style: normal;
		}
	}

	.confirm {
		padding: 1em;
	}

	.note {
		padding: 1em;
		color: ${props => props.theme.color.gray7};
		margin: 1rem 0 0;
		font-size: 0.9rem;
		border-radius: ${props => props.theme.borderRadius.base};
		background: ${props => props.theme.color.gray2};

		strong {
			color: ${props => props.theme.color.gray8};
		}
	}
`;
